'use strict';

export default [
  {
    name: `Home`,
    model: `Home`,
    id: 1,
    path: `home`,
  },
];



// WEBPACK FOOTER //
// ./client/models/global/menu.js